import { call, put, takeLatest } from 'redux-saga/effects';
import api from 'services/api';

import { Creators as ComercialCampaignsActions, Types as ComercialCampaignsTypes } from 'store/ducks/commercialCampaign';


function* getComercialCampaignsRequest(action) {
  try {
    const { page, per, active } = action.payload;
    const url = `experience/v2/commercial_campaigns?page=${page}&per=${per}`;
    const response = yield call(api.get, url, {
      params: {
        status_value: active !== undefined ? active : null
      }
    });

    yield put(ComercialCampaignsActions.getComercialCampaignsSuccess(response.data));
  } catch (error) {
    yield put(ComercialCampaignsActions.getComercialCampaignsFailure());
  }
}


export default function* sagaComercialCampaigns() {
  yield takeLatest(ComercialCampaignsTypes.GET_LIST_REQUEST, getComercialCampaignsRequest);
}
